import { render, staticRenderFns } from "./IndexJiazhang03.vue?vue&type=template&id=41155572&scoped=true&"
import script from "./IndexJiazhang03.vue?vue&type=script&lang=js&"
export * from "./IndexJiazhang03.vue?vue&type=script&lang=js&"
import style0 from "./IndexJiazhang03.vue?vue&type=style&index=0&id=41155572&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41155572",
  null
  
)

export default component.exports